/*
 * Copyright (c) Dito Technologies
 */

import {graphql} from "babel-plugin-relay/macro"

export default graphql`
    query PieceSettingsQuery($piece_id: ID!) {
        music_viewer {
            ...PieceSettingsBody_viewer
            piece(id: $piece_id) {
                id
                ...PieceSettingsBody_piece
            }
        }
    }
`;